import { DefaultPaymentPeriod } from "@/data/enums/products";
import i18n from "@/i18n";

const PaymentPeriodsMap = () => {
  return {
    [DefaultPaymentPeriod.INHERIT_FROM_BRAND]: {
      id: DefaultPaymentPeriod.INHERIT_FROM_BRAND,
      label: i18n.t("_.payment_periods.inherit_from_brand")
    },
    [DefaultPaymentPeriod.HIGHEST_PRICE]: {
      id: DefaultPaymentPeriod.HIGHEST_PRICE,
      label: i18n.t("_.payment_periods.highest_price")
    },

    [DefaultPaymentPeriod.LOWEST_PRICE]: {
      id: DefaultPaymentPeriod.LOWEST_PRICE,
      label: i18n.t("_.payment_periods.lowest_price")
    },

    [DefaultPaymentPeriod.LOWEST_MONTHLY_PRICE]: {
      id: DefaultPaymentPeriod.LOWEST_MONTHLY_PRICE,
      label: i18n.t("_.payment_periods.lowest_monthly_price")
    }
  };
};

export { PaymentPeriodsMap };
